// ヘッダー用のオンライン人数表示（ユーザーIDで重複排除済み）

import React from "react";
import { Tag, Tooltip } from "antd";
import { useOnlineCount } from "../hooks/usePresence";

export default function OnlineUsers() {
  const { count } = useOnlineCount(120000);

  return (
    <Tooltip title="オンライン判定は直近2分以内のハートビート">
      {/* 表示文言を日本語に（例: オンライン人数） */}
      <Tag style={{ marginLeft: 12, fontWeight: 600 }}>オンライン人数: {count}</Tag>
    </Tooltip>
  );
}
